module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.89e3a903.png";